import { manageAPI } from "./index.js";

const unwrap = (body) => body?.data ?? body;

// Product Georestrictions (management API, saucey_admin only)
export const getProductGeorestrictions = async () => {
  return unwrap((await manageAPI.get("merchant/admin/product-georestrictions")).data);
};

export const createProductGeorestriction = async (data) => {
  return unwrap((await manageAPI.post("merchant/admin/product-georestrictions", data)).data);
};

export const updateProductGeorestriction = async (id, data) => {
  return unwrap(
    (await manageAPI.put(`merchant/admin/product-georestrictions/${encodeURIComponent(id)}`, data)).data
  );
};

export const deleteProductGeorestriction = async (id) => {
  return unwrap(
    (await manageAPI.delete(`merchant/admin/product-georestrictions/${encodeURIComponent(id)}`)).data
  );
};
